<style scoped lang="scss">
.small-card {
  .box-card {
    margin-bottom: 20px;
    ::v-deep.el-card__header {
      padding: 16px 20px 0 24px;
      border-bottom: 1px solid #f0f0ff;
      div {
        .title {
          font-size: 14px;
          color: #262626;
          font-weight: 600;
        }
        .btns {
          float: right;
        }
      }
    }
  }
}
.datas-container {
  .video-box {
    overflow: hidden;
    zoom: 1;
    margin-right: -12px;
    .item {
      width: 95px;
      height: 95px;
      float: left;
      margin-right: 8px;
      margin-bottom: 10px;
      position: relative;
      &:last-child {
        margin-right: 0;
      }
      .num {
        position: absolute;
        left: 0;
        top: 0;
        width: 16px;
        height: 16px;
        background: rgba(0, 0, 0, 0.25);
        text-align: center;
        line-height: 16px;
        color: #fff;
        font-size: 12px;
      }
      .delete {
        position: absolute;
        right: 0;
        top: 0;
        width: 16px;
        height: 16px;
        background: #1890ff;
        text-align: center;
        line-height: 16px;
        color: #fff;
        font-size: 12px;
        cursor: pointer;
        opacity: 0;
      }
      .detail {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 16px;
        height: 16px;
        margin: -8px 0 0 -8px;
        background: #1890ff;
        text-align: center;
        line-height: 16px;
        color: #fff;
        font-size: 12px;
        opacity: 0;
        cursor: pointer;
      }
      .video {
        width: 95px;
        height: 95px;
        background-color: #262626;
      }
      &:hover {
        .delete,
        .detail {
          opacity: 1;
        }
      }
    }
  }
}
.meter-text {
  font-size: 12px;
  color: #999;
  line-height: 20px;
  margin-bottom: 12px;
}
.preview-video {
  width: 100%;
}
</style>
<template>
  <div>
    <SpCardContent
      title="视频管理"
      class="smallCard"
      :btns="
        disabled
          ? null
          : [
            { key: 'clear', name: '清空', type: 'text' },
            { key: 'edit', name: '编辑视频', type: 'primary' }
          ]
      "
      @btnsOption="managerOperate"
    >
      <div class="meter-text">
        已选择 {{ meters.videos.length }} 个，最多选择9个视频，拖动以排序
      </div>
      <div class="datas-container">
        <div
          v-if="meters"
          class="video-box"
        >
          <draggable
            v-model="meters.videos"
            @start="onStart"
            @end="onEnd"
          >
            <div
              v-for="(item, index) in meters.videos"
              :key="index"
              class="item"
            >
              <span class="num">{{ index + 1 }}</span>
              <video
                class="video"
                :src="item"
              />
              <span
                v-if="meters.time_type === 3"
                class="delete"
                @click="removeVideo(index)"
              >X</span>
              <span
                class="detail"
                @click="previewVideo(item)"
              ><i
                class="icon1 el-icon-zoom-in"
              /></span>
            </div>
          </draggable>
        </div>
      </div>
    </SpCardContent>
    <!-- 选择视频 -->
    <SpVideoSelect
      v-model="videoVisible"
      @chooseVideo="chooseVideo"
    />
    <el-dialog
      width="650px"
      :visible.sync="dialogVisible"
    >
      <video
        class="preview-video"
        controls
        autoplay
        :src="dialogVideoUrl"
      />
    </el-dialog>
  </div>
</template>

<script>
// 第三方组件
import draggable from 'vuedraggable'

export default {
  name: 'MeterVideoManager',
  components: {
    draggable
  },
  props: {
    meters: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVideoUrl: '', // 预览图地址
      dialogVisible: false, //图片预览模态框展示与否
      videoVisible: false
    }
  },
  computed: {},
  watch: {
    meters (nVal, oVal) {
      console.log('nVal------->', nVal)
      this.videoVisible = nVal.videoVisible
    }
  },
  mounted () {
    console.log('222------>', this.meters)
  },
  methods: {
    managerOperate (key) {
      if (key === 'clear') {
        this.meters.videos = []
      }
      if (key === 'edit') {
        this.videoVisible = true
      }
    },
    // 选择视频
    chooseVideo (selectdata) {
      let selectVideoData = []
      selectdata.forEach((v) => {
        selectVideoData.push(v.image_url)
      })
      if (this.meters.videos.length + selectVideoData.length > 9) {
        if (this.meters.videos.length > 0) {
          this.$message.error(
            '最多添加9个,您最多还可以选择' + (9 - this.meters.videos.length) + '个'
          )
        } else {
          this.$message.error('最多添加9个,您已经选择了' + selectVideoData.length + '个')
        }
      } else {
        this.meters.videos = this.meters.videos.concat(selectVideoData)
        this.videoVisible = false
      }
    },
    // 删除视频
    removeVideo: function (i) {
      this.meters.videos.splice(i, 1)
    },
    // 视频预览
    previewVideo (item) {
      this.dialogVisible = true
      this.dialogVideoUrl = item
    },

    // 拖拽绑定事件
    onStart (evt) {
      console.log(evt)
    },
    onEnd (evt) {
      console.log(evt)
    }
  }
}
</script>
